import React, { Component } from 'react'

import PropTypes from 'prop-types'
import { translate } from 'react-i18next'
import { compose } from 'react-apollo'
import { client } from './../../index'
import gql from 'graphql-tag'
import moment from 'moment'
import getByPath from 'lodash/get'
import isFunction from 'lodash/isFunction'
import { Draggable } from 'react-beautiful-dnd'
import config from '../../config'
import _ from 'lodash'

import { NotificationManager } from 'react-notifications'
import MaterialTimePicker from 'material-ui/TimePicker'
import DatePicker from 'react-datepicker'
import { getDurationView } from './../../libs/utils'


class Activity extends Component {
  static propTypes = {
    type: PropTypes.string.isRequired,
    data: PropTypes.object.isRequired,
    onTimeEdited: PropTypes.func,
    onDateEdited: PropTypes.func,
    onEditClick: PropTypes.func,
    onClick: PropTypes.func,
    onRemove: PropTypes.func
  }

  constructor(props) {
    super(props)

    this.state = {
      newTime: moment(),
      isTimeEditing: false
    }
    console.log('triggered')
  }

  onTimeClick() {
    this.setState({
      newTime: moment(this.props.data.startdate),
      isTimeEditing: true
    })
  }

  onDateClick() {
    this.setState({
      newDate: moment(this.props.data.startdate),
      isDateEditing: true
    })
  }

  onDatePickerClose() {
    this.setState(
      {
        isDateEditing: false
      },
      () => {
        if (isFunction(this.props.onDateEdited)) {
          this.props.onDateEdited(this.props.data, this.state.newDate)
        }
      }
    )
  }



  onTimePickerClose() {
    this.setState(
      {
        isTimeEditing: false
      },
      () => {
        if (isFunction(this.props.onTimeEdited)) {
          this.props.onTimeEdited(this.props.data, this.state.newTime)
        }
      }
    )
  }

  getDurationView(start, end) {
    const { t } = this.props

    let durationView
    let duration
    if (start && end) {
      const startDate = moment(start)
      const endDate = moment(end)
      duration = endDate.diff(startDate, 'minutes')
      const days = parseInt(duration / 1440)
      const reminderDays = duration - days * 1440
      const hours = parseInt(reminderDays / 60)
      const minutes = reminderDays - hours * 60
      durationView = ''
      if (days > 0) {
        durationView += days + ' ' + (days == 1 ? t('one_day') : t('days')) + ' '
      }
      if (hours > 0) {
        durationView += hours + ' ' + (hours == 1 ? t('one_hour') : t('hours')) + ' '
      }
      if (minutes > 0) {
        durationView += minutes + ' ' + (minutes == 1 ? t('one_minute') : t('minutes')) + ' '
      }
    }
    return durationView
  }

  removeDependecies = data => {
    console.log('activity data', data)
    if (data.__typename !== 'Note') {
      if (_.get(data, 'contentEvents.length', 0) < 1) {
        client
          .mutate({
            mutation: gql`
              mutation removeContentPOI($id: ID!) {
                updateContentPOI(id: $id, tripGuruId: null) {
                  id
                }
              }
            `,
            variables: {
              id: data.id
            }
          })
          .then(() => {
            NotificationManager.success('POI removed', 'Success', 5000)
            setTimeout(async () => {
              await this.props.refetch()
            }, 0)
          })
          .catch(err => {
            NotificationManager.error('Cant remove POI', 'Error', 5000)
          })
      }
    } else {
      if(data.itineraryDays.length<1){
        client
          .mutate({
            mutation: gql`
              mutation removeNote($id: ID!) {
                updateNote(id: $id, user: null) {
                  id
                }
              }
            `,
            variables: {
              id: data.id
            }
          })
          .then(() => {
            NotificationManager.success('Note removed', 'Success', 5000)
            setTimeout(async () => {
              await this.props.refetch()
            }, 0)
          })
          .catch(err => {
            NotificationManager.error('Cant remove Note', 'Error', 5000)
          })
      } else{
        NotificationManager.warning('Before remove note, you must remove it from all trips', 'Warning', 5000)
      }
    }
  }

  renderTime() {
    if (this.state.isTimeEditing) {
      return (
        <div className="plan-part__time-input">
          <MaterialTimePicker
            id={this.props.data.id}
            ref={input => {
              this.timePicker = input
            }}
            className="material-time-picker"
            format="24hr"
            value={this.state.newTime && this.state.newTime.toDate()}
            onChange={(_, value) => {
              this.setState(
                {
                  newTime: moment(value)
                },
                () => {
                  const isOpen = getByPath(this, 'timePicker.refs.dialogWindow.state.open', true)

                  if (!isOpen) {
                    this.onTimePickerClose()
                  }
                }
              )
            }}
          />
        </div>
      )
    } 
    else if (this.state.isDateEditing) {
      return (
        <div className="plan-part__date-input">
          <DatePicker
            className="form-control"
            minDate={moment(this.props.tripStart)}
            maxDate={moment(this.props.tripEnd)}
            selected={this.state.newDate}
            placeholderText="-- / -- / ----"
            onSelect={(date, index) => {
              this.setState(
                {
                  newDate: date.startOf('day')
                },
                () => {
                  this.onDatePickerClose()
                }
              )
            }}
          />
        </div>
      )
    } 
    else {
      let durationView = getDurationView(this.props.data.startdate, this.props.data.enddate, this.props.t)
      let timeView = moment(this.props.data.startdate).format('HH:mm')
      let dateView = moment(this.props.data.startdate).format('DD MMM')
      let timeDuration = timeView + (durationView ?  ', ' + durationView : '')
      return (
        <div>
          <span className="plan-part__time" onClick={() => this.onTimeClick()}>
            {timeDuration}
          </span>
          <span className="plan-part__date" onClick={() => this.onDateClick()}>
            {dateView}
          </span>
        </div>
      )
    }
  }

  render() {
    const { data, type, onClick, onRemove, onEditClick } = this.props
    let photo = data.defaultPhoto ? data.defaultPhoto : null
    if (!photo && data.eventPhotos && data.eventPhotos.length > 0) {
      photo = data.eventPhotos[0].file
    }
    return type === 'plan-part' ? (
      //this is wrong if. It will render activities if they are, or liblrary part if not
      <Draggable draggableId={data.id}>
        {(provided, snapshot) => (
          <div {...provided.dragHandleProps} ref={provided.innerRef} style={{ ...provided.draggableStyle }}>
            <div className="trip__plan-part plan-part">
              <hr />
              {this.renderTime()}
              <div className="plan-part__title flex">
                <span>{data.title}&nbsp;</span>
                <div className="flex">
                  <span className="plan-part__action" onClick={() => onEditClick(data)}>
                    <i className="icon-edit" />
                  </span>
                  <span className="plan-part__action" onClick={() => onRemove(data.id)}>
                    <i className="icon-delete" />
                  </span>
                </div>
              </div>
              <div className="plan-part__search-result search-result">
                <img
                  src={photo ? photo.s3Url : 'http://via.placeholder.com/150x90'}
                  className="search-result__photo"
                  style={{height: "90px"}}
                  alt=""
                />
                {/*
                <div className="search-result__title wordwrap" dangerouslySetInnerHTML={{ __html: data.description }}></div>
                */}
              </div>
            </div>
          </div>
        )}
      </Draggable>
    ) : (
      <Draggable draggableId={data.id}>
        {(provided, snapshot) => (
          <div {...provided.dragHandleProps} ref={provided.innerRef} style={provided.draggableStyle} className="plan-part__POI_edit">
            <div>
              <div className=" plan-part__POI__icon">
                <span className=" plan-part__POI__action ">
                  <i className="icon-edit" onClick={() => onEditClick(data)} />
                  <i
                    className="icon-delete"
                    style={{ paddingLeft: 8, color: _.get(data, 'contentEvents.length', 0) === 0 ? '' : 'grey' }}
                    onClick={() => this.removeDependecies(data)}
                  />
                </span>
              </div>
            </div>
            <div className="library__search-result search-result" onClick={() => isFunction(onClick) && onClick(data)}>
              <div className="search-result__photo">
                <img src={photo ? photo.s3Url : 'http://via.placeholder.com/86x60'} alt="" style={{height: "60px"}}/>
              </div>

              <div style={{ wordBreak: 'normal' }} className="search-result__title">
                {data.title}
              </div>
            </div>
          </div>
        )}
      </Draggable>
    )
  }
}

const enhance = compose(translate('trip_planner'))
export default enhance(Activity)



// WEBPACK FOOTER //
// src/components/TripPlanner/Activity.js